import { type HTMLAttributes, type ReactNode } from 'react';
import { cn } from './cn';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export interface PageHeaderStickyProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title: ReactNode;
  breadcrumb?: ReadonlyArray<BreadcrumbItem>;
  /** 왼쪽 보조 액션 (deprecated — primaryActions 사용 권장) */
  secondaryActions?: ReactNode;
  /** 헤더 우측 액션 (delete / publish 등). cancel/save 는 StickyFooter 권장. */
  primaryActions?: ReactNode;
  /** 단순 actions prop alias */
  actions?: ReactNode;
}

export const PageHeaderSticky = ({
  title,
  breadcrumb,
  secondaryActions,
  primaryActions,
  actions,
  className,
  ...props
}: PageHeaderStickyProps) => (
  <header
    className={cn('flex flex-col gap-2 pb-4', className)}
    style={{ borderBottom: '1px solid var(--divider-strong)' }}
    {...props}
  >
    {breadcrumb && breadcrumb.length > 0 && (
      <nav aria-label="breadcrumb">
        <ol className="flex items-center gap-1.5 text-[12px]" style={{ color: 'var(--content-muted)' }}>
          {breadcrumb.map((item, idx) => (
            <li key={idx} className="flex items-center gap-1.5">
              {idx > 0 && <span aria-hidden="true">/</span>}
              {item.href ? (
                <a href={item.href} className="hover:text-[color:var(--content-strong)] hover:underline">
                  {item.label}
                </a>
              ) : (
                <span>{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    )}
    <div className="flex items-center justify-between gap-4">
      <h1
        className="text-[22px] font-semibold"
        style={{
          fontFamily: 'var(--font-display)',
          color: 'var(--content-strong)',
          lineHeight: 'var(--leading-heading)',
          letterSpacing: 'var(--tracking-tight)',
        }}
      >
        {title}
      </h1>
      <div className="flex shrink-0 items-center gap-2">
        {secondaryActions}
        {primaryActions ?? actions}
      </div>
    </div>
  </header>
);
